import React, { Component } from "react";
import { withSnackbar } from "notistack";
import {Grid} from "@material-ui/core";
import BasicDetailHeader from "../../BasicDetailHeader";
import { UpdateLLpTaskFormApi, uploadLLpFileApi, importLLpFileApi, exportLLpAssetDetailListApi, deleteLLpAssetDetailRow, fillLLpEditFormApi, DownloadAllApi ,exportMasterApi,bulkDelete,onArchiveAsset} from "../apiService";
import { convertFilterObject, removeEmptyKey, filterOptions, permissionCheckFnforCamo,} from "../../../../utils";
import { EmptyCollection, PageLoader, AccessDenied,DeletePopUp } from "../../../../shared_elements";
import LLpSearch from "../components/LLpSearch";
import { getllpApi } from "../apiService";
import LLpTable from "../components/LLpTable";
import { LLpTableHead } from "./LLpTableHead"
import LLpList from "../components/LLpList";
import { trackActivity } from '../../../../utils/mixpanel';
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
class LLPComponents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addFormDialog: false,
			sidebarOpen: true,
			tabIndex: 0,
			pageLoader: false,
			sort: "",
			sort_by: "",
			assetsDetail: {
				list: [],
				pagination: {},
				asset_count: {},
				new_task_last_used_folder_uuid: '',
				checkbox_last_used_folder_uuid: "",
				last_used_folder_uuid_link_document: '',
				checkbox_last_used_folder_name: ''
			},
			headerData: {},
			searchData: "",
			headerTsn: "",
			headerCsn: "",
			currentRecordPerPage: 250,
			basicDetails:{},
			isBasicDetailExpanded: true,
			uuid: "",
			slug:'',
			thrust_detail:{},
			bulkOperation: { modal: false, ids: [], title: '', type: '' },
			archiveModal:false
		}


		this.openAddForm = this.openAddForm.bind(this);
		this.downloadAllApi = DownloadAllApi.bind(this);
		this.closeAddForm = this.closeAddForm.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.deleteLLpAssetDetailRow = deleteLLpAssetDetailRow.bind(this);
		this.handleEditRow = fillLLpEditFormApi.bind(this);
		// this.getAircraftDetailApi = getAircraftDetailApi.bind(this);
		this.UpdateLLpTaskFormApi = UpdateLLpTaskFormApi.bind(this);
		this.uploadLLpFileApi = uploadLLpFileApi.bind(this);
		this.importLLpFileApi = importLLpFileApi.bind(this);
		this.exportLLpAssetDetailListApi = exportLLpAssetDetailListApi.bind(this);

		this.getllpApi = getllpApi.bind(this);
		this.exportMasterApi = exportMasterApi.bind(this);
		this.bulkDelete = bulkDelete.bind(this);
		this.onArchiveAsset = onArchiveAsset.bind(this);
	}

	componentDidMount() {
		this.getData(null);
		this.pullData();
		trackActivity('LLP Status Page Visited - CAMO', {
			event_type: 'Page Visited',
			page_title: 'LLP Components',
		})
	}
	pullData = (slug, tsn, csn, dom, thrust) => {
		this.setState({ slug: slug });
		this.setState({ headerTsn: tsn });
		this.setState({ headerCsn: csn });
		this.setState({ thrust_detail: thrust })
	};
	uuidData = (uuid) => {
		this.setState({ uuid: uuid });
	}
	getData(item) {
		this.getllpApi(
			{ per_page: this.state.currentRecordPerPage },
			"skeletonLoader",
			this.props,
			item ? item : null
		);
	}

	// mainHeaderData = () => {
	// 	getAircraftDetailApi().then((response) => {
	// 		const data = response.data.data;
	// 		this.setState({ headerData: data });
	// 	});
	// };

	openAddForm() {
		this.setState({ addFormDialog: true });
	}
	closeAddForm() {
		this.setState({ addFormDialog: false });
	}

	toggleSidebar() {
		this.setState({ sidebarOpen: !this.state.sidebarOpen });
	}

	createSortHandler = (sortField) => {
		const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
		this.setState({
			sort: sortField,
			sort_by: sort_by === "asc" ? "desc" : "asc",
		})
		if (sort_by === "asc") {
			this.getllpApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
		} else {
			this.getllpApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
		}
	};

	submitFilter = (filterOptions) => {
		const { tabIndex, applyingFilter } = this.state;
		this.getllpApi({ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, }, "pageLoader", this.props);
	};

	searchResults = (item) => {
		if (item !== null) {
			this.getData(item);
		}
	};

	updateFormData = async (updateId, updatedData, props,close,formclose) => {
		await this.UpdateLLpTaskFormApi( updateId, updatedData, props, this.state.currentRecordPerPage,close,formclose);
	};

	fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
		await this.uploadLLpFileApi(
			uploadId,
			formdata,
			props,
			this.state.currentRecordPerPage,
			haveAttachments
		);
	};

	importFile = (formData, props, isXLSX) => {
		this.importLLpFileApi(
			formData,
			props,
			isXLSX,
			this.state.currentRecordPerPage
		);
	};
	downloadAllFilesApi = (props) => {
		this.downloadAllApi(props);
	};

	exportAssetDetailListFunc = (props) => {
		const { basicDetails } = this.state;
		this.exportLLpAssetDetailListApi(props, '', this.props, basicDetails);
	};

	refreshComp = () => {
		this.getData();
	};
	engineType=(data)=>{
		this.setState({basicDetails:data})
	}

	toggleBulkOps = async (flag, type, item) => {
        const { bulkOperation, assetsDetail } = this.state;   
        try {
            if (type === 'bulk') {
                const response = await this.getllpApi(
                    { per_page: flag ? assetsDetail?.pagination?.total : this.state.currentRecordPerPage},
                    "skeletonLoader",
                    this.props,
                    null
                );
                this.setState({
                    bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
                });
            } else {
                this.setState({
                    bulkOperation: {
                        ...bulkOperation,
                        type: 'single',
                        ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

	render() {
		const { tabIndex, applyingFilter, sort, sort_by, assetsDetail, pageLoader, uuid ,slug,thrust_detail,bulkOperation,basicDetails,archiveModal, isBasicDetailExpanded} = this.state;
		const { aircraftTypes, engineTypes, lessees } = this.props;
		
		let filterOptions = "assetFilterOps";
		if (tabIndex === 0 || tabIndex === 1) {
			filterOptions = {
				...filterOptions,
				aircraft_type: {
					...filterOptions.aircraft_type,
					options: aircraftTypes,
				},
			};
			if (tabIndex === 1) {
				delete filterOptions.engine_type;
			}
		}
		if (tabIndex === 0 || tabIndex === 2) {
			filterOptions = {
				...filterOptions,
				engine_type: {
					...filterOptions.engine_type,
					options: engineTypes,
				},
			};
			if (tabIndex === 2) {
				delete filterOptions.aircraft_type;
			}
		}

		filterOptions = {
			...filterOptions,
			lessee: {
				...filterOptions.lessee,
				options: lessees,
			},
		};
		const tablehead_a = thrust_detail  && Object.keys(thrust_detail)?.length === 5 && 
		Object.values(thrust_detail).map(row => ({ label: row }))
		const tablehead_b = thrust_detail  && Object.keys(thrust_detail)?.length === 2 && 
		Object.values(thrust_detail).map(row => ({ label: row }))
		const tablehead_c = thrust_detail  && Object.keys(thrust_detail)?.length === 3 && 
		Object.values(thrust_detail).map(row => ({ label: row }))
		const tablehead_d = thrust_detail  && Object.keys(thrust_detail)?.length === 6 && 
		Object.values(thrust_detail).map(row => ({ label: row }))
		const thrustTableHead_a = [
			{ id: "action", label: "Action(s)" },
			{ id: "module_type", label: "Module", sortOption: true },
			{ id: "description", label: "Description", sortOption: true },
			{ id: "part_number", label: "Part Number", sortOption: true },
			{ id: "serial_number", label: "Serial Number", sortOption: true },
			{ id: "tsn", label: "TSN", sortOption: false },
			{ id: "csn", label: "CSN", sortOption: false },
			{ id: "COOTR_thrust_a", label: tablehead_a && tablehead_a[0]?.label, sortOption: true },
			{ id: "COOTR_thrust_b", label: tablehead_a && tablehead_a[1]?.label, sortOption: true },
			{ id: "COOTR_thrust_c", label: tablehead_a && tablehead_a[2]?.label, sortOption: true },
			{ id: "COOTR_thrust_d", label: tablehead_a && tablehead_a[3]?.label, sortOption: true },
			{ id: "COOTR_thrust_e", label: tablehead_a && tablehead_a[4]?.label, sortOption: true },
			{ id: "life_limit_thrust_a", label: tablehead_a && tablehead_a[0]?.label, sortOption: true ,isColor:true },
			{ id: "life_limit_thrust_b", label: tablehead_a && tablehead_a[1]?.label, sortOption: true ,isColor:true },
			{ id: "life_limit_thrust_c", label: tablehead_a && tablehead_a[2]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_d", label: tablehead_a && tablehead_a[3]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_e", label: tablehead_a && tablehead_a[4]?.label, sortOption: true ,isColor:true},
			{ id: "", label: tablehead_a && tablehead_a[0]?.label, sortOption: false },
			{ id: "", label: tablehead_a && tablehead_a[1]?.label, sortOption: false },
			{ id: "", label: tablehead_a && tablehead_a[2]?.label, sortOption: false },
			{ id: "", label: tablehead_a && tablehead_a[3]?.label, sortOption: false },
			{ id: "", label: tablehead_a && tablehead_a[4]?.label, sortOption: false },
			{ id: "remarks", label: "Remarks", sortOption: true },
			{ id: "attachment", label: "Attachment" },
		]
		const thrustTableHead_b = [
			{ id: "action", label: "Action(s)" },
			{ id: "module_type", label: "Module", sortOption: true },
			{ id: "description", label: "Description", sortOption: true },
			{ id: "part_number", label: "Part Number", sortOption: true },
			{ id: "serial_number", label: "Serial Number", sortOption: true },
			{ id: "tsn", label: "TSN", sortOption: false },
			{ id: "csn", label: "CSN", sortOption: false },
			{ id: "COOTR_thrust_a", label: tablehead_b && tablehead_b[0]?.label, sortOption: true },
			{ id: "COOTR_thrust_b", label: tablehead_b && tablehead_b[1]?.label, sortOption: true },
			{ id: "life_limit_thrust_a", label: tablehead_b && tablehead_b[0]?.label, sortOption: true,isColor:true },
			{ id: "life_limit_thrust_b", label: tablehead_b && tablehead_b[1]?.label, sortOption: true,isColor:true},
			{ id: "", label: tablehead_b && tablehead_b[0]?.label, sortOption: false },
			{ id: "", label: tablehead_b && tablehead_b[1]?.label, sortOption: false },
			{ id: "remarks", label: "Remarks", sortOption: true },
			{ id: "attachment", label: "Attachment" },
		]
		const thrustTableHead_c = [
			{ id: "action", label: "Action(s)" },
			{ id: "module_type", label: "Module", sortOption: true },
			{ id: "description", label: "Description", sortOption: true },
			{ id: "part_number", label: "Part Number", sortOption: true },
			{ id: "serial_number", label: "Serial Number", sortOption: true },
			{ id: "tsn", label: "TSN", sortOption: false },
			{ id: "csn", label: "CSN", sortOption: false },
		    { id: "COOTR_thrust_a",label: tablehead_c && tablehead_c[0]?.label, sortOption: true },
			{ id: "COOTR_thrust_b", label: tablehead_c && tablehead_c[1]?.label, sortOption: true },
			{ id: "COOTR_thrust_c", label: tablehead_c && tablehead_c[2]?.label, sortOption: true },
			{ id: "life_limit_thrust_a", label: tablehead_c && tablehead_c[0]?.label, sortOption: true,isColor:true },
			{ id: "life_limit_thrust_b", label: tablehead_c && tablehead_c[1]?.label, sortOption: true,isColor:true },
			{ id: "life_limit_thrust_b", label: tablehead_c && tablehead_c[2]?.label, sortOption: true,isColor:true},
			{ id: "", label: tablehead_c && tablehead_c[0]?.label, sortOption: false },
			{ id: "", label: tablehead_c && tablehead_c[1]?.label, sortOption: false },
			{ id: "", label: tablehead_c && tablehead_c[2]?.label, sortOption: false },
			{ id: "remarks", label: "Remarks", sortOption: true },
			{ id: "attachment", label: "Attachment" },
		]
		const thrustTableHead_d = [
			{ id: "action", label: "Action(s)" },
			{ id: "module_type", label: "Module", sortOption: true },
			{ id: "description", label: "Description", sortOption: true },
			{ id: "part_number", label: "Part Number", sortOption: true },
			{ id: "serial_number", label: "Serial Number", sortOption: true },
			{ id: "tsn", label: "TSN", sortOption: false },
			{ id: "csn", label: "CSN", sortOption: false },
			{ id: "COOTR_thrust_a", label: tablehead_d && tablehead_d[0]?.label, sortOption: true },
			{ id: "COOTR_thrust_b", label: tablehead_d && tablehead_d[1]?.label, sortOption: true },
			{ id: "COOTR_thrust_c", label: tablehead_d && tablehead_d[2]?.label, sortOption: true },
			{ id: "COOTR_thrust_d", label: tablehead_d && tablehead_d[3]?.label, sortOption: true },
			{ id: "COOTR_thrust_e", label: tablehead_d && tablehead_d[4]?.label, sortOption: true },
			{ id: "COOTR_thrust_f", label: tablehead_d && tablehead_d[5]?.label, sortOption: true },
			{ id: "life_limit_thrust_a", label: tablehead_d && tablehead_d[0]?.label, sortOption: true ,isColor:true },
			{ id: "life_limit_thrust_b", label: tablehead_d && tablehead_d[1]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_c", label: tablehead_d && tablehead_d[2]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_d", label: tablehead_d && tablehead_d[3]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_e", label: tablehead_d && tablehead_d[4]?.label, sortOption: true ,isColor:true},
			{ id: "life_limit_thrust_f", label: tablehead_d && tablehead_d[5]?.label, sortOption: true ,isColor:true},
			{ id: "", label: tablehead_d && tablehead_d[0]?.label, sortOption: false },
			{ id: "", label: tablehead_d && tablehead_d[1]?.label, sortOption: false },
			{ id: "", label: tablehead_d && tablehead_d[2]?.label, sortOption: false },
			{ id: "", label: tablehead_d && tablehead_d[3]?.label, sortOption: false },
			{ id: "", label: tablehead_d && tablehead_d[4]?.label, sortOption: false },
			{ id: "", label: tablehead_d && tablehead_d[5]?.label, sortOption: false },
			{ id: "remarks", label: "Remarks", sortOption: true },
			{ id: "attachment", label: "Attachment" },
		]
		
		 const LLpTableHeadMainHead = [
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "Total Since New", sortOption: false, colspan: 2 },
			{ id: "", label: "Operated Cycles", sortOption: false, colspan: 5 },
			{ id: "", label: "Life Limit", sortOption: false, colspan: 5 },
			{ id: "", label: "Cycles Remaining", sortOption: false, colspan: 5 },
			{ id: "", label: "", sortOption: false },
			{ id: "", label: "", sortOption: false },

		]
		return (
			<section className="amp-listing-section">
				{pageLoader ? <PageLoader /> : null}
				<Grid className="mt-0" spacing={3} container>
					<Grid className="pr-0 pt-0" xs={12} item>
						<SubDetails
							masterExport={true}
							title="Life Limited Parts (LLPs)"
							slug={slug}
							module='llp'
							match={this.props?.match}
							onRefresh={this.refreshComp}
							permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
						/>
						<BasicDetailHeader props={this.props} func={this.pullData} engineType={this.engineType} uuid={this.uuidData} module='llp' onAccordionChange={(expanded) => this.setState({ isBasicDetailExpanded: expanded })} />
						{permissionCheckFnforCamo({
							primaryKey: "ad_status",
							keyIndex: "R",
						}) ? (
							<div className="custom-border">
								<LLpSearch
									currentRecordPerPage={this.state.currentRecordPerPage}
									headerTsn={this.state.headerTsn}
									headerCsn={this.state.headerCsn}
									applyingFilter={applyingFilter}
									filterOptions={filterOptions}
									tabIndex={tabIndex}
									uuid={uuid}
									basicDetails={basicDetails}
									thrust_detail={thrust_detail}
									pageLoader={"pageLoader"}
									getResponseBack={this.refreshComp}
									props={this.props}
									importFile={this.importFile}
									fileUploadData={this.fileUploadData}
									searchData={(e) => this.searchResults(e.target.value)}
									exportReportFn={(file) =>
										this.exportAssetDetailListFunc(
											{
												download: file.extension,
												...{
													...convertFilterObject(
														removeEmptyKey(applyingFilter),
														filterOptions
													),
													asset_type: tabIndex,
													...(sort === "" && sort_by === "" ? {} : { sort, sort_by }),
												},
											},
											"pageLoader"
										)
									}
								/>
								<LLpTable
									currentRecordPerPage={this.state.currentRecordPerPage}
									heads={thrust_detail && Object.keys(thrust_detail)?.length === 6 ? thrustTableHead_d : thrust_detail && Object.keys(thrust_detail)?.length === 5 ? thrustTableHead_a : thrust_detail && Object.keys(thrust_detail)?.length === 2 ? thrustTableHead_b : thrust_detail && Object.keys(thrust_detail)?.length === 3 ? thrustTableHead_c : LLpTableHead}
									sort={sort}
									thrust_detail={thrust_detail}
									sort_by={sort_by}
									basicDetails={basicDetails}
									isBasicDetailExpanded={isBasicDetailExpanded}
									bulkDeletefn={()=>this.bulkDelete(this.props,bulkOperation, assetsDetail.pagination.per_page,)}
                                    bulkOperation={bulkOperation}
                                    bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
                                    toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
									data={assetsDetail?.list?.map((item, index) => (
										<LLpList
											bulkOperation={bulkOperation}
											toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
											currentRecordPerPage={this.state.currentRecordPerPage}
											key={index}
											item={item}
											index={index}
											uuid={uuid}
											basicDetails={basicDetails}
											assetsDetail={assetsDetail}
											thrust_detail={thrust_detail}
											last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
											last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
											checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
											checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
											headerTsn={this.state.headerTsn}
											headerCsn={this.state.headerCsn}
											handleDeleteRow={(data) =>
												this.deleteLLpAssetDetailRow(
													item,
													this.props,
													this.state.currentRecordPerPage
												)
											}
											updateFormData={this.updateFormData}
											handleEditRow={(data) =>
												this.handleEditRow(item, this.props)
											}
											getResponseBack={this.refreshComp}
											props={this.props}
											fileUploadData={this.fileUploadData}
											downloadAllApi={(file) =>
												this.downloadAllFilesApi(
													{
														download: file.extension,
														...{
															...convertFilterObject(
																removeEmptyKey(applyingFilter),
																filterOptions
															),
															asset_type: tabIndex,
															item,
														},
													},

													"pageLoader"
												)
											}
										/>
									))}
									createSortHandler={this.createSortHandler}
									pagination={assetsDetail.pagination}
									onChangePage={(event, newPage) =>
										this.getllpApi(
											{
												...convertFilterObject(
													removeEmptyKey({
														...applyingFilter,
														asset_type: this.state.tabIndex,
														per_page: assetsDetail.pagination.per_page,
														page: newPage + 1,
													}),
													filterOptions
												),
											},
											"pageLoader",
											this.props
										)
									}
									onChangeRowsPerPage={(event) =>
										this.setState(
											{ currentRecordPerPage: event.target.value },
											() => {
												this.getllpApi(
													{
														...convertFilterObject(
															removeEmptyKey({
																...applyingFilter,
																asset_type: this.state.tabIndex,
																per_page: this.state.currentRecordPerPage,
															}),
															filterOptions
														),
													},
													"pageLoader",
													this.props
												);
											}
										)
									}
									noRecord={
										assetsDetail?.list?.length ? null : !this.state.pageLoader ? (
											<EmptyCollection title="No Records Found" />
										) : null
									}
								/>
							</div>
						) : (
							<AccessDenied />
						)}
					</Grid>
				</Grid>
				{
                    archiveModal ?
                        <DeletePopUp
                            title='Archive Asset'
                            deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
                            modal={() => this.setState({ archiveModal: true })}
                            content='Are you sure, you want to Archive?'
                            toggleModalFn={() => this.setState({ archiveModal: false })}
                            confirmText="ARCHIVE"
                        />
                        : null
                }
			</section>
		);
	}
}
export default withSnackbar(LLPComponents);
